var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriangleWarningOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.857,
    height: 19.414,
    viewBox: "0 0 21.857 19.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning_icon",
    "data-name": "warning icon",
    transform: "translate(-205.348 -398.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(206.375 399.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_387",
    "data-name": "\\uD328\\uC2A4 387",
    d: "M10.608,5.272l-8.026,13.6a1.949,1.949,0,0,0-.005,1.915A1.891,1.891,0,0,0,4.2,21.76H20.255a1.891,1.891,0,0,0,1.626-.971,1.949,1.949,0,0,0-.005-1.915l-8.026-13.6a1.881,1.881,0,0,0-3.241,0Z",
    transform: "translate(-2.328 -4.346)",
    fill: "none",
    stroke: "#ffb013",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_388",
    "data-name": "\\uD328\\uC2A4 388",
    d: "M18,13.5v3.848",
    transform: "translate(-8.099 -7.629)",
    fill: "none",
    stroke: "#ffb013",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_389",
    "data-name": "\\uD328\\uC2A4 389",
    d: "M18,25.5h0",
    transform: "translate(-8.099 -11.934)",
    fill: "none",
    stroke: "#ffb013",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarningOrange);
export default __webpack_public_path__ + "static/media/triangle_warning_orange.90f0b68bfacbf2e14102e94f43e32b43.svg";
export { ForwardRef as ReactComponent };